<template>
  <a-card :bordered="false">
    <a-form ref="form" :model="search" :initialValues="search" layout="inline">
      <a-form-item label="请选择">
        <a-select
          v-model:value="search.search_date_type"
          style="width: 120px"
          @focus="focus"
          ref="select"
          @change="handleChange"
        >
          <a-select-option value="1">日</a-select-option>
          <a-select-option value="2">自然周</a-select-option>
          <a-select-option value="3">自然月</a-select-option>
          <a-select-option value="4">近7天</a-select-option>
          <a-select-option value="5">自定义时间</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="">
        <a-date-picker
          v-model:value="search.search_time"
          v-if="search.search_date_type == '1'"
          valueFormat="YYYY-MM-DD"
          format="YYYY-MM-DD"
          :disabled-date="disabledDateValue" @change="isData"/>
        <a-week-picker
          v-model:value="weekTime"
          v-else-if="search.search_date_type == '2'" @change="changeWeek"/>
        <a-month-picker
          v-model:value="search.search_time"
          v-else-if="search.search_date_type == '3'"
          valueFormat="YYYY-MM"
          format="YYYY-MM" @change="isData" />
        <a-range-picker
          v-model:value="search.search_time"
          v-else-if="search.search_date_type == '5'"
          valueFormat="YYYY-MM-DD"
          format="YYYY-MM-DD"
          :disabled-date="disabledDate"
          :defaultPickerValue="defaultValue"
          @calendarChange="calendarPriceRangeChange"
          @change="changePriceRangeDate"
        />
      </a-form-item>

      <a-form-item>
        <a-button type="primary" htmlType="submit" @click="init">搜索</a-button>
        <a-button type="primary" htmlType="submit" class="m-l-20" v-has:integralStatisticsGoodExport="exportTable">导出列表</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <a-row :gutter="[24, 16]">
      <a-col :span="6" class="s_bf">
        <!-- <div ref="echartsLeft" style="width:100%;height:400px"></div> -->
        <div :class="{'item_shadow':active==1}" class="item" @click="changeTab(1)">
          <div class="fz-16">兑换商品个数（个）</div>
          <div class="fz-30 s_font_b">{{dataNum.exchange_product_total_all || 0}}</div>
        </div>
      </a-col>
      <a-col :span="6" class="s_bf">
        <!-- <div ref="echartsRight" style="width:100%;height:400px"></div> -->
        <div :class="{'item_shadow':active==2}" class="item" @click="changeTab(2)">
          <div class="fz-16">兑换人数（人）</div>
          <div class="fz-30 s_font_b">{{dataNum.user_total_all || 0}}</div>
        </div>
      </a-col>
      <a-col :span="6" class="s_bf">
        <!-- <div ref="echartsRight" style="width:100%;height:400px"></div> -->
        <div :class="{'item_shadow':active==3}" class="item" @click="changeTab(3)">
          <div class="fz-16">支付积分数（个）</div>
          <div class="fz-30 s_font_b">{{dataNum.pay_point_total_all || 0}}</div>
        </div>
      </a-col>
      <a-col :span="6" class="s_bf">
        <!-- <div ref="echartsRight" style="width:100%;height:400px"></div> -->
        <div :class="{'item_shadow':active==4}" class="item" @click="changeTab(4)">
          <div class="fz-16">支付金额（个）</div>
          <div class="fz-30 s_font_b">{{dataNum.pay_price_total_all || 0}}</div>
        </div>
      </a-col>
    </a-row>
    <!-- 折线 -->
    <a-spin :spinning="loading" style="width:100%">
    <a-row :gutter="[24, 16]">
      <div ref="charts" style="width: 100%; height: 400px"></div>
    </a-row>
     </a-spin>
  </a-card>
  <a-card :bordered="false" >
    <div class="m-t-10 m-b-10 fz-16">商品明细</div>
    <a-table
      :pagination="pagination"
      :loading="loading"
      bordered
      rowKey="category_name"
      :columns="columns"
      :data-source="tableList"
      @change="handleTableChange"
    >
      <!-- <template v-slot:action="{ record }">
        <a-button
          @click="
            $router.push({
              path: '/onlineOrder/statics/storeOrderStatics/detail',
              query: {
                buyer_id: record.buyer_id,
                search_date_type: search.search_date_type,
                search_time: search.search_time,
                weekTime: weekTime,
              },
            })
          "
          >查看详情</a-button
        >
      </template> -->
    </a-table>
    
  </a-card>
  
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs,h } from "vue";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import moment from "moment";
import {productStatistics} from '@/api/integralShop'
import { iscode } from "@/utils/app";
 import { message } from "ant-design-vue";
 import config from "@/config";
const def = {
  search_date_type: "1",
  search_time: "",
  limit: 10,
  page: 1,
  end_time:'',
  start_time:''
};
export default {
  setup() {
    const search = ref({...def})
    const oss = config.oss[process.env.VUE_APP_type];
    let columns = [
      {
        title: "商品名称",
        dataIndex: "exchange_name",
        key: "exchange_name",
         customRender:function({record}){
            return h('div',{
              style:{
                'display':'flex',
                'align-items':'center',
                'height':'60px',
              }
            },[h('img',{
              src: record.exchange_image?oss+record.exchange_image : require('@/assets/images/normal.png'),
              style:{
                 'width':"60px",
                 'height':'60px',
                 'marginRight':'20px',
                 "display":'block'
              }
            },''),record.exchange_name || '-'])
        }
      },
      {
        title: "规格",
        dataIndex: "exchange_sku_name",
        key: "exchange_sku_name",
        customRender:function({record}){
          return record.exchange_sku_name || '-'
        }
      },
      {
        title: "所在分类",
        dataIndex: "category_name",
        key: "category_name",
      },
      {
        title: "兑换数量（个）",
        dataIndex: "exchange_product",
        key: "exchange_product",
      },
      {
        title: "支付积分（个）",
        dataIndex: "pay_point",
        key: "pay_point",
        // sorter: (a, b) => a.refund_point_price_total - b.refund_point_price_total,
      },
       {
        title: "支付金额（元）",
        dataIndex: "pay_price",
        key: "pay_price",
        
      }
    //   {
    //     title: "操作",
    //     dataIndex: "action",
    //     key: "action",
    //     slots: { customRender: "action" },
    //   },
    ];
    const state = reactive({
      active: "1",
      showDealer: false,
      selectPriceDate: "",
      offsetDays: 86400000 * 90,
      defaultValue:[],

       pagination:{ //分页
        total:0,
        current:1,
        pageSize:10
      },
      loading: false,
      tableList:[],
      exchange_product:[],
      pay_point:[],
      pay_price:[],
      user:[],
      dataX:[],
      dataY:[],
      dataNum:{},
      is_day:true
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [], 
    });
    const { dateTargets, typeToStartEnd,dataBefore } = useTime();
    // 切换周
    const momentTime = inject("momentTime");
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    // 切换时间
    const handleChange = (e) => {
        search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = dataBefore();
           search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("1").start_time;
          state.is_day = true;
          break;
        case "2":
          search.value.search_time =typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
          dateTime.weekTime = typeToStartEnd("week").end_time;
           search.value.start_time = typeToStartEnd("7").start_time;
          search.value.end_time = typeToStartEnd("7").end_time;
          state.is_day = true;
          break;
        case "3":
          search.value.search_time = dateTargets("month");
           search.value.start_time = typeToStartEnd("month").start_time;
          search.value.end_time = typeToStartEnd("month").end_time;
          state.is_day = true;
          break;
          case '4':
            search.value.search_time = typeToStartEnd("1").start_time;
            search.value.end_time = typeToStartEnd("1").end_time;
            search.value.start_time = typeToStartEnd("7").start_time;
             state.is_day = true;
          break;
          case "5":
        //   console.log(dateTargets(),'22')
          search.value.search_time = [dataBefore(),dataBefore()]
           search.value.start_time = search.value.search_time[0]
          search.value.end_time = search.value.search_time[1]
           state.is_day = true;
          break;
      }
    };

     const getLine = async () => {
      switch (search.value.search_date_type) {
        case "1":
          search.value.end_time = search.value.search_time;
          search.value.start_time = search.value.search_time;
          break;
        case "2":
          search.value.start_time = search.value.search_time.split(",")[0];
          search.value.end_time = search.value.search_time.split(",")[1];
          break;
        case "3":
          search.value.start_time = moment(search.value.search_time).startOf("month").format("YYYY-MM-DD");
          search.value.end_time = moment(search.value.search_time).endOf("month").format("YYYY-MM-DD");
          break;
          case "4":
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("7").start_time;
          break;
          case "5":
           search.value.start_time = search.value.search_time[0]
          search.value.end_time = search.value.search_time[1]
          break;
      }
     }
    


  

    const charts = ref(null);
    let myChart;

    onMounted(async () => {
      handleChange("1");
      await methods.init()
      
    });
    const setCharts = () => {
      myChart = useECharts(charts.value);
      let option = {
        tooltip: { trigger: "axis" },
        legend: {
          show: false,
        },
        xAxis: {
          type: "category",
          data: state.dataX,
          boundaryGap: false, //坐标轴两边不留白
        },
        yAxis: {
          type: "value",
          show: true,
          nameTextStyle: {
            color: "#000",
            fontWeight: 800,
            fontSize: 14,
          },
        },
        grid: {
          y: 80,
          x: 60,
        },
        series: [
          {
            name: ["商品销量"],
            data: state.dataY,
            type: "line",
            symbolSize: 6,
            smooth: true,
            color: "#1890ff",
            areaStyle: {
              color: "#e7f3ff",
            },
          },
        ],
      };
      myChart.setOptions(option);
    }; 

    //
    const methods = { 
      disabledDate(current) {
       
        if (state.selectPriceDate) {
             
          let selectV = moment(state.selectPriceDate, 'YYYY-MM-DD').valueOf()
          return (current > moment().subtract(1, "days") || current >moment(new Date(selectV + state.offsetDays), "YYYY-MM-DD")) || current < moment(new Date(selectV - state.offsetDays), "YYYY-MM-DD")
        } else {
           return current && current > moment().subtract(1, "days");
        }
      },
      changePriceRangeDate(e) {
        state.is_day = !!e[0];
        state.selectPriceDate = "";
      },
      //选择开始时间/结束时间
      calendarPriceRangeChange(date) {
        state.selectPriceDate = date[0];
      },
       disabledDateValue(current){
           return current && current > moment().subtract(1, "days");
       },
      async exportTable(){ //导出
        const hide = message.loading("正在加载中...", 0);
       getLine()
        let result=await productStatistics({...search.value,excel:1}).then(res=>res.data)
        setTimeout(hide);
        if(iscode(result,true)){
          window.open(result.data.action)
        }
      },
      changeTab(val){
         state.loading = true;
          state.active = val;
          if(val == 1){
            state.dataY = state.exchange_product;
          }else if(val==2){
            state.dataY = state.user;
          }else if(val==3){
            state.dataY = state.pay_point;
          }else{
            state.dataY = state.pay_price;
          }
          setCharts()
          setTimeout(()=>{
            state.loading = false;
          },300)
      },
      async init(){
      if(!state.is_day){
         message.error("请选择日期！");
        return;
      }
        const hide = message.loading("正在加载中...", 0);
         state.pagination.current=1;
        search.value.page = 1;
        state.tableList = [];
       await methods.getSearch()
        setTimeout(hide);
      },
     async getSearch(){
        state.loading = true;
        state.tableList = [];
        getLine()
        let res = await productStatistics({...search.value}).then(res=>res.data)
         state.loading = false;
        if(iscode(res)){
          let {data,date,exchange_product,list,pay_point,pay_price,user} = res.data || {};
          state.tableList = list.data || [];
          state.pagination.total = list.total || 0;
          state.exchange_product = exchange_product || [];
          state.pay_point = pay_point || [];
          state.pay_price = pay_price || [];
          state.user = user || [];
          state.dataX = date || [];
          state.dataNum = data || {};
          await methods.changeTab(state.active)
           setCharts()
        }else{
          state.tableList = [];
          message.error(res.msg)
        }
      },
      handleTableChange(e) {
         state.tableList = []
        state.pagination.current=e.current;
        search.value.page = e.current;
        methods.getSearch()
      }

    };
    const isData = function(val){
      state.is_day = !!val
    }

    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      handleChange,
      isData,
      columns,
      changeWeek,
      // onSearch,
      charts,
      ...methods,
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}

.item {
  box-shadow: 0px 0px 1px 0 rgba(0, 0, 0, 0.3);
  padding: 35px 0 ;
  border-radius: 8px;
  text-align: center;
  background: #fbfcfc;
  cursor: pointer;
}
.item_shadow{
  box-shadow: 3px 8px 14px 0 rgba(0, 0, 0, 0.3);

}
</style>